import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 注册积分商城相关路由
 */
export default [
  // 积分商城首页
  route('/integral', 'integral', component('integral/index')),
  // 明细
  route('/integral-log', 'integral-log', component('integral/integral-log')),
  // 积分规则
  route('/integral-rule', 'integral-rule', component('integral/integral-rule'))
]
